module.exports = __webpack_public_path__ + "static/media/customer-bec.ef431d33.png";